import { Component, OnInit } from '@angular/core';
import { RolesService } from '../../../services/roles.service';
import { Role } from '../../../models/role';
import { ChartModule } from 'primeng/chart';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-role-distribution-widget',
  standalone: true,
  imports: [ChartModule, TranslatePipe],
  templateUrl: './role-distribution-widget.component.html',
  styleUrl: './role-distribution-widget.component.scss'
})
export class RoleDistributionWidgetComponent implements OnInit {
  data: any = { labels: [], datasets: [{ label: '', data: []}] };
  options: any = {
    responsive: true,
    maintainAspectRatio: false,
  };
  isLoading = true;
  errorMessage: string | null = null;

  constructor(private rolesService: RolesService, private translateService: TranslateService) {}

  ngOnInit() {
    this.isLoading = true;
    this.errorMessage = null;
    this.rolesService.getRoles().subscribe({
      next: (roles: Role[]) => {
        // Trie les roles du plus grand au plus petit nombre de personnes
        const sortedRoles = [...roles].sort(
          (a, b) => (b.peoples?.length || 0) - (a.peoples?.length || 0)
        );
        this.data.labels = sortedRoles.map(role => role.name);
        this.data.datasets[0].data = sortedRoles.map(role =>
          Array.isArray(role.peoples) ? role.peoples.length : 0
        );
        this.data = { ...this.data };
        this.isLoading = false;
      },
      error: () => {
        this.translateService.get('DASHBOARD.ERRORS.ERROR_LOADING_ROLES').subscribe((translatedMessage: string) => {
          this.errorMessage = translatedMessage;
        });
        // this.errorMessage = 'Erreur lors du chargement des roles';
        this.isLoading = false;
      }
    });
  }
}